import { Box, CircularProgress } from '@mui/material';

import React from 'react';

export const Spinner = ({ size }: { size?: number }) => (
  <Box>
    <CircularProgress size={size ? size : 200} />
  </Box>
);
